import { useTranslation } from "react-i18next";

import { useWorkspaceSettingsStore } from "../../store/useWorkspaceSettingsStore";

import { SettingsCard } from "./SettingsCard";

import { Progress } from "@/components/ui/progress";

export const StorageUsageCard = () => {
  const { t } = useTranslation(["workspaces"]);
  const { settings } = useWorkspaceSettingsStore();

  if (!settings) return null;

  const { storage_usage } = settings;
  const usagePercentage = storage_usage.usage_percentage;

  const getUsageColor = (percentage: number) => {
    if (percentage >= 90) return "text-destructive";
    if (percentage >= 70) return "text-warning";

    return "text-muted-foreground";
  };

  const action = (
    <div className="flex items-center gap-2 max-sm:flex-col">
      <div className="w-16 max-sm:w-10">
        <Progress className="h-2" value={usagePercentage} />
      </div>
      <span className={`text-xs font-medium ${getUsageColor(usagePercentage)}`}>
        {usagePercentage}%
      </span>
    </div>
  );

  return (
    <SettingsCard
      action={action}
      bottomCircle="from-amber-500 to-orange-600"
      bottomCirclePlacement="bottom-left"
      bottomCircleSize="h-20 w-20"
      description={t("workspaces:settings.storage.description", {
        defaultValue: "{{used}} of {{total}} used",
        used: storage_usage.total_size_formatted,
        total: storage_usage.max_size_formatted,
      })}
      icon="mdi:harddisk"
      title={t("workspaces:settings.storage.title", { defaultValue: "Storage Usage" })}
      topCircle="from-emerald-500 to-teal-600"
      topCirclePlacement="top-right"
      topCircleSize="h-16 w-16"
    >
      {/* No children needed - status is shown in action */}
    </SettingsCard>
  );
};
